
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
